export default {

  methods: {
    /// this check if the GEO location is outside of GB,US,CA,AU and then append +44 to the given A tag's href and innerHTML
    ObserveInfinityNumberTag(element, replaceInnerHtml) {
      const self = this;
      const observer = new MutationObserver(((mutations) => {
        mutations.forEach((mutation) => {
          const isROW = (['gb', 'us', 'ca', 'au'].includes(self.$store.getters['common/getOfficeStatus'].countryCode) === false);
          if (isROW === true && mutation.target.href.indexOf('+44') === -1) {
            const number = mutation.target.href.split(':')[1];
            mutation.target.href = `tel:+44${number}`;
            mutation.target.innerHTML = replaceInnerHtml ? (`+44 ${mutation.target.innerHTML}`) : '';
          }
          else if (isROW === false && replaceInnerHtml === false) {
            mutation.target.innerHTML = '';
          }
          observer.disconnect();
        });
      }));
      observer.observe(element, {
        attributes: true, // configure it to listen to attribute changes
      });
    },
  },

};
